"use client";
import Header from "@/components/common/header";
import Hero from "@/components/home/hero";
import ProjectArea from "@/components/home/project-area";
import Testimonial from "@/components/common/testimonial";
import ClientArea from "@/components/common/client-area";
import BlogArea from "@/components/common/blog-area";
import AboutArea from "@/components/home/about-area";
import ServiceArea from "@/components/common/service-area-2";
import FaqArea from "@/components/common/faq-area";
import { faq } from "@/data/data";
import Footer from "@/components/common/footer";
import ICP from "@/components/home/icp";
import ServiceAreaOther from "@/components/home/service-area-other";
import PreFooter from "@/components/common/preFooter";
import ServiceAreaOtherpage from "@/components/pages/(service)/service-area-other";
import { useModal } from "@/hooks/useModal";
import { useState } from "react";
import FormModal from "@/components/common/form-modal";

const Home = () => {
  const modal = useModal();
  const [modalTitle, setModalTitle] = useState("Get the Growth Kit");
  const handleModalOpen = (modalTitle?: string) => {
    if (modalTitle) {
      setModalTitle(modalTitle);
    }
    modal.openModal();
  };

  const getSubmitButtonText = (title: string) => {
    const lowerTitle = title.toLowerCase();
    if (lowerTitle.includes("download") || lowerTitle.includes("downlode")) {
      return "Download";
    }
    return "Request";
  };
  return (
    <>
      <Header />
      <Hero />
      <ICP />
      <AboutArea />
      <ServiceArea />
      <ServiceAreaOther
        title="Grab your growth kit"
        description="Pick the fast path made for your stage. Ship faster, earn predictably, and run ops with less friction."
        onModalOpen={handleModalOpen} />
      <ProjectArea />
      <Testimonial headline="Why leaders choose Desilo" />
      <ClientArea />
      <div className="section-padding-top">
        <ServiceAreaOtherpage title="Why Desilo?" />
      </div>
      <BlogArea />
      <FaqArea style="style-1" title={"Frequently asked questions"} items={faq} />
      <PreFooter
        title={"Ready to turn vision into action?"}
        description={"Collaborate with our experts to define clear goals and build actionable strategies for success."}
        onModalOpen={handleModalOpen}
      />
      <Footer />

      {/* Form Modal */}
      <FormModal
        isOpen={modal.isOpen}
        onClose={modal.closeModal}
        onSubmit={() => {
          modal.closeModal();
        }}
        title={modalTitle}
        submitButtonText={getSubmitButtonText(modalTitle)}
        dialogSlug={modalTitle}
      />
    </>
  );
};

export default Home;
